import * as React from 'react'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { MAP_SIZES_TO_PROPS } from '../../../constants'
import { compose } from 'recompose'
import withSizes from 'react-sizes'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters={true} {...props} sx={{ 
    boxShadow: 'none',
  }}/>
))(({ theme }) => ({
}))

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowRightIcon 
        sx={{ 
          color: props.isMobile ? 'inherit' : '#000000', 
          fontSize: '1.5rem'
        }}
      />
    }
    {...props}
    sx={{ 
      padding: '0px 6px 0px 0px',
      minHeight: 0
    }}
  />
))(({ theme }) => ({
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginBottom: 0,
    marginTop: 0
  },
  '& .MuiButtonBase-root': {
    padding: '0px',
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
}))

function TwistedAccordion(props) {
  const { isMobile, items, title } = props
  const [expanded, setExpanded] = React.useState('')

  const handleChange =
    (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false)
    }

  return (
    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
      <AccordionSummary isMobile={isMobile} aria-controls="panel1d-content" id="panel1d-header">
        <Typography sx={ !isMobile ? { fontWeight: 'bold' } : {}}>{ title }</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ 
        flexDirection: 'row',
        alignItems: 'center',
        maxHeight: '18vh',
        overflowY: 'scroll',
        minWidth: 100
      }}>
        {
          items.map((item) => (
            <Link href={item.href} underline="none" sx={{ color: '#000000' }}>
              <Typography sx={ !isMobile ? { 
                marginTop: '6px',
                marginBottom: '6px',
                textAlign: 'left',
                fontWeight: 'bold'
              }: {
                textAlign: 'left',
              }}>
                {item.name}
              </Typography>
            </Link>
            
          ))
        }
      </AccordionDetails>
    </Accordion>
  )
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(TwistedAccordion)